<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">Edit LR</h1>
        <button
          class="btn btn-dark btn-sm"
          matTooltip="Back"
          matTooltipPosition="left"
          mat-raised-button
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/lrmanagement">
            Manage LR
          </li>
          <li class="breadcrumb-item active" aria-current="page">Edit LR</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-xl-12">
      <form [formGroup]="editLR">
        <div class="col-md-12 mb-3">
          <!-- <h4 class="text-dark fw-bold mb-0">Edit LR</h4> -->
          <p style="font-size: 13px">Edit your following details.</p>
        </div>
        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">
                Basic Details ({{ this.particlarLR?.LR_no }})
              </h4>
            </div>

            <div class="row">
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Manual LR No.</label>
                  <div class="d-flex align-items-center">
                    <input
                      type="text"
                      class="form-control me-1 shadow-none"
                      id="manualLR_noctrl"
                      placeholder="Enter Manual LR No."
                      formControlName="manualLR_no"
                      (focus)="onManualLRFocus()"
                      (blur)="onManualLRBlur()"
                    />

                    <small
                      class="text-danger"
                      *ngIf="
                        editLR.get('manualLR_no')?.touched &&
                        editLR.get('manualLR_no')?.hasError('duplicate')
                      "
                    >
                      Manual LR number already exists
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Supervisor Name </label>
                  <select
                    id="supervisornamectrl"
                    formControlName="supervisorname"
                    placeholder="Select Status"
                    class="form-control shadow-none"
                  >
                    <option selected value="null">
                      --Select Supervisor Name--
                    </option>
                    <option *ngFor="let s of superVisor" value="{{ s._id }}">
                      {{ s.full_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Company Name</label>

                  <select
                    *ngIf="isRoleSuperVisor"
                    id="clientListctrl"
                    formControlName="clientList"
                    placeholder="Select Company Name"
                    class="form-control shadow-none"
                  >
                    <!-- <option   value="">--Select Client Name--</option> -->
                    <option *ngFor="let cl of clientList" value="{{ cl._id }}">
                      {{ cl.clientName }}
                    </option>
                  </select>
                  <select
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    id="clientListctrl"
                    formControlName="clientList"
                    placeholder="Select Client Name"
                    class="form-control shadow-none"
                  >
                    <!-- <option   value="">--Select Client Name--</option> -->
                    <option *ngFor="let cl of clientList" value="{{ cl._id }}">
                      {{ cl.clientName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- consignoor -->
        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Consignee & Consignor</h4>
            </div>

            <div class="row">
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Consignee Name</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      id="ConsigneeNamectrl"
                      placeholder="Enter Consignee Name"
                      formControlName="ConsigneeName"
                    />

                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      id="ConsigneeNamectrl"
                      placeholder="Enter Consignee Name"
                      formControlName="ConsigneeName"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Consignee Address</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="ConsigneeAddressctrl"
                    class="form-control shadow-none"
                    placeholder="Enter Consignee Address"
                    formControlName="ConsigneeAddress"
                  />

                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="ConsigneeAddressctrl"
                    class="form-control shadow-none"
                    placeholder="Enter Consignee Address"
                    formControlName="ConsigneeAddress"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Consignor Name</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      id="ConsignorNamectrl"
                      placeholder="Enter Consignor Name"
                      formControlName="ConsignorName"
                    />
                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      id="ConsignorNamectrl"
                      placeholder="Enter Consignor Name"
                      formControlName="ConsignorName"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Consignor Address</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="ConsignorAddressctrl"
                    class="form-control shadow-none"
                    placeholder="Enter Consignor Address"
                    formControlName="ConsignorAddress"
                  />
                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="ConsignorAddressctrl"
                    class="form-control shadow-none"
                    placeholder="Enter Consignor Address"
                    formControlName="ConsignorAddress"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vehicle & Trip Details -->

        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Vehicle & Trip Details</h4>
            </div>

            <div class="row">
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Vehicle No.</label>
                  <input
                    type="text"
                    id="VehicleNoctrl"
                    class="form-control shadow-none"
                    placeholder="Enter Vechicle No."
                    formControlName="VehicleNo"
                    [matAutocomplete]="autoVehicleNo"
                  />
                  <mat-autocomplete
                    autoActiveFirstOption
                    #autoVehicleNo="matAutocomplete"
                  >
                    <mat-option
                      *ngFor="let option of filteredVehicleNo | async"
                      [value]="option"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Vehicle Type</label>
                  <input
                    type="text"
                    id="vehicleTypectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Vehicle Type"
                    formControlName="vehicleType"
                    [matAutocomplete]="autoVehicleType"
                  />
                  <mat-autocomplete
                    autoActiveFirstOption
                    #autoVehicleType="matAutocomplete"
                  >
                    <mat-option
                      *ngFor="let option of filteredVehicleTypes | async"
                      [value]="option"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Date</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="date"
                      class="form-control me-1 shadow-none"
                      id="datectrl"
                      formControlName="date"
                      [min]="yesterday"
                      [max]="today"
                      (change)="onKeyDate($event)"
                    />

                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="date"
                      class="form-control me-1 shadow-none"
                      id="datectrl"
                      placeholder="Enter date"
                      formControlName="date"
                    />
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">From</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="fromctrl"
                    class="form-control shadow-none"
                    placeholder="Enter From"
                    formControlName="from"
                  />
                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="fromctrl"
                    class="form-control shadow-none"
                    placeholder="Enter From"
                    formControlName="from"
                  />
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">To</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="toctrl"
                    class="form-control shadow-none"
                    placeholder="Enter To"
                    formControlName="to"
                  />
                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="toctrl"
                    class="form-control shadow-none"
                    placeholder="Enter To"
                    formControlName="to"
                  />
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Trip Starting Date</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="date"
                      class="form-control me-1 shadow-none"
                      placeholder="Enter Start Time"
                      id="tripSDatectrl"
                      formControlName="tripSDate"
                    />
                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="date"
                      class="form-control me-1 shadow-none"
                      placeholder="Enter Start Time"
                      id="tripSDatectrl"
                      formControlName="tripSDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Trip End Date</label>
                  <div class="d-flex align-items-center">
                    <input
                      type="date"
                      class="form-control me-1 shadow-none"
                      placeholder="Enter End Time"
                      id="tripEDatectrl"
                      formControlName="tripEDate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Compliance & Value  -->
        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Compliance & Value</h4>
            </div>

            <div class="row">
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">GSTIN</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      id="GSTINctrl"
                      placeholder="Enter GSTIN"
                      formControlName="GSTIN"
                    />
                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      id="GSTINctrl"
                      placeholder="Enter GSTIN"
                      formControlName="GSTIN"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Road Permit number</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="RoadPermitNoctrl"
                    class="form-control shadow-none"
                    placeholder="Enter Road Permit No."
                    formControlName="RoadPermitNo"
                  />
                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="RoadPermitNoctrl"
                    class="form-control shadow-none"
                    placeholder="Enter Road Permit No."
                    formControlName="RoadPermitNo"
                  />
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">DLY</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="DLYctrl"
                    class="form-control shadow-none"
                    placeholder="Enter DLY"
                    formControlName="DLY"
                  />
                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="DLYctrl"
                    class="form-control shadow-none"
                    placeholder="Enter DLY"
                    formControlName="DLY"
                  />
                </div>
              </div>
              <div class="col-lg-4 col-xl-4 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Declared Value</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="DeclaredValuectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Declared Value"
                    disabled
                    formControlName="DeclaredValue"
                  />
                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="DeclaredValuectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Declared Value"
                    disabled
                    formControlName="DeclaredValue"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Transporter & Driver -->
        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Transporter & Driver</h4>
            </div>

            <div class="row">
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Transporter Name</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="transportorNamectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Transporter Name"
                    formControlName="transportorName"
                  />

                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="transportorNamectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Transporter Name"
                    formControlName="transportorName"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Transporter Mobile</label>
                  <input
                    *ngIf="isRoleSuperVisor"
                    type="text"
                    id="transportorMobilectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Transporter Mobile"
                    formControlName="transportorMobile"
                  />

                  <input
                    disabled
                    *ngIf="!isRoleSuperVisor"
                    type="text"
                    id="transportorMobilectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Transporter Mobile"
                    formControlName="transportorMobile"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Driver Name</label>
                  <input
                    type="text"
                    id="driverNamectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Driver Name"
                    formControlName="driverName"
                    [matAutocomplete]="autoDriverName"
                  />
                  <mat-autocomplete
                    autoActiveFirstOption
                    #autoDriverName="matAutocomplete"
                  >
                    <mat-option
                      *ngFor="let option of filteredDriverName | async"
                      [value]="option"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-autocomplete>
                  <!-- <input disabled *ngIf="!isRoleSuperVisor" type="text" id="driverNamectrl"
                                class="form-control shadow-none" placeholder="Enter Driver Name"
                                formControlName="driverName"> -->
                </div>
              </div>
              <div class="col-lg-6 col-xl-6 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Driver Mobile</label>
                  <input
                    type="text"
                    id="driverMobilectrl"
                    class="form-control shadow-none"
                    placeholder="Enter Driver Mobile"
                    formControlName="driverMobile"
                    [matAutocomplete]="autoDriverNumber"
                  />
                  <mat-autocomplete
                    autoActiveFirstOption
                    #autoDriverNumber="matAutocomplete"
                  >
                    <mat-option
                      *ngFor="let option of filteredDriverNumber | async"
                      [value]="option"
                    >
                      {{ option }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Payment Details -->
        <div class="contentbox mb-3">
          <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
              <h4 class="text-dark fw-bold mb-0">Payment Details</h4>
            </div>

            <div class="row">
              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Vehicle Rate</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Vehicle Rate"
                      id="vehicleRatectrl"
                      formControlName="vehicleRate"
                    />
                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      placeholder="Vehicle Rate"
                      id="vehicleRatectrl"
                      formControlName="vehicleRate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Advance</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Advance"
                      id="advancectrl"
                      formControlName="advance"
                    />

                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      placeholder="Advance"
                      id="advancectrl"
                      formControlName="advance"
                    />
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Balance Paid</label>
                  <div class="d-flex align-items-center">
                    <input
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Balance Paid"
                      disabled
                      (focusout)="onFocusOutEvent($event)"
                      id="balancePaidctrl"
                      formControlName="balancePaid"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                <div class="form-group accountsinp mb-3">
                  <label for="">Actual Balance</label>
                  <div class="d-flex align-items-center">
                    <input
                      *ngIf="isRoleSuperVisor"
                      type="number"
                      class="form-control me-1 shadow-none"
                      placeholder="Actual Balance"
                      id="balancectrl"
                      formControlName="balance"
                      readonly
                    />
                    <input
                      disabled
                      *ngIf="!isRoleSuperVisor"
                      type="text"
                      class="form-control me-1 shadow-none"
                      placeholder="Balance"
                      id="balancectrl"
                      formControlName="balance"
                    />
                  </div>
                </div>
              </div>

              <!-- TDS -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="form-group accountsinp mb-3">
                  <label>TDS</label>
                  <input
                    type="number"
                    class="form-control shadow-none"
                    id="TDSctrl"
                    placeholder="Enter TDS"
                    formControlName="TDS"
                  />
                </div>
              </div>

              <!-- Munsipal Amount -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="form-group accountsinp mb-3">
                  <label>Munsipal Amount</label>
                  <input
                    type="number"
                    class="form-control shadow-none"
                    id="munsipalAmountctrl"
                    placeholder="Enter Munsipal Amount"
                    formControlName="munsipalAmount"
                  />
                </div>
              </div>

              <!-- Final Amount (MANUAL INPUT) -->
              <div class="col-lg-4 col-md-4 col-sm-6 col-12">
                <div class="form-group accountsinp mb-3">
                  <label>Final Amount</label>
                  <input
                    type="number"
                    class="form-control shadow-none"
                    id="finalAmountctrl"
                    placeholder="Enter Final Amount"
                    formControlName="finalAmount"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Freight & Expenses -->

        <div class="contentbox mt-3">
          <div class="row account">
            <div class="col-12 border-bottom pb-3 mb-3 border-gray">
              <h4 class="text-dark fw-bold mb-0">Freight & Expenses</h4>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="quantityctrl"
                  >Quantity/Weight<sup class="text-danger">*</sup></label
                >
                <!-- <p class="para" style="color: #989BAC;font-size: 14px;">Enter the invoice number for this trip</p> -->
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  *ngIf="isRoleSuperVisor"
                  type="text"
                  id="quantityctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Quantity/Weight"
                  formControlName="quantity"
                />
                <input
                  disabled
                  *ngIf="!isRoleSuperVisor"
                  type="text"
                  id="quantityctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Quantity/Weight"
                  formControlName="quantity"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="Frieghtctrl"
                  >Freight<sup class="text-danger">*</sup></label
                >
                <!-- <p class="para" style="color: #989BAC;font-size: 14px;">Enter the total value of the invoice.</p> -->
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  *ngIf="isRoleSuperVisor"
                  type="text"
                  class="form-control me-1 shadow-none"
                  placeholder="Enter Freight Value"
                  id="Frieghtctrl"
                  formControlName="Frieght"
                />
                <input
                  disabled
                  *ngIf="!isRoleSuperVisor"
                  type="text"
                  class="form-control me-1 shadow-none"
                  placeholder="Enter Freight Value"
                  id="Frieghtctrl"
                  formControlName="Frieght"
                />
              </div>
            </div>
            <!-- Other PAYMENT -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Other payment</label>
                <!-- <p class="para" style="color: #989BAC;font-size: 14px;">Enter the total number of articles shipped.</p> -->
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="Other payment"
                  id="otherPaymentctrl"
                  formControlName="otherPayment"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.otherPayment.invalid && ff.otherPayment.touched"
                >
                  Only numbers should be accepted
                </span>
                <!-- Other Payment Description -->
                <input
                  type="text"
                  class="form-control mt-3 shadow-none"
                  id="otherPaymentDescriptionctrl"
                  placeholder="Enter description"
                  formControlName="otherPaymentDescription"
                />
              </div>
            </div>
            <!-- Detention -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Detention</label>
                <!-- <p class="para" style="color: #989BAC;font-size: 14px;">Enter the total weight of the shipment.</p> -->
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="Detention"
                  id="detentionctrl"
                  formControlName="detention"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.detention.invalid && ff.detention.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>
            <!-- Labour loading -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Labour Loading</label>
                <!-- <p class="para" style="color: #989BAC;font-size: 14px;">Enter the total weight of the shipment.</p> -->
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="labour Load"
                  id="labourLoadctrl"
                  formControlName="labourLoad"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.labourLoad.invalid && ff.labourLoad.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>

            <!-- labour Unloading -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label for="">Labour Unloading</label>
                <!-- <p class="para" style="color: #989BAC;font-size: 14px;">Enter the total weight of the shipment.</p> -->
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <input
                  type="number"
                  class="form-control me-1 shadow-none"
                  placeholder="labour Unload"
                  id="labourUnloadctrl"
                  formControlName="labourUnload"
                />
                <span
                  class="text-danger"
                  *ngIf="ff.labourUnload.invalid && ff.labourUnload.touched"
                >
                  Only numbers should be accepted
                </span>
              </div>
            </div>

            <!-- Loading Slip Attachment -->
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <label>Loading Slip Attachment</label>
              </div>

              <div class="col-12 col-md-6 col-lg-4 mb-3">
                <div class="d-flex align-items-center gap-2">
                  <!-- Input showing last uploaded file -->
                  <input
                    type="text"
                    class="form-control shadow-none"
                    [value]="lastTollFileName"
                    placeholder="No file uploaded"
                    readonly
                    style="flex: 1 1 auto; min-width: 0"
                  />

                  <!-- Hidden file input -->
                  <input
                    type="file"
                    accept="image/*,application/pdf"
                    (change)="fileChangeEventtollAttachment($event)"
                    class="d-none"
                    id="loadingSlipAttachmentCtrl"
                    multiple
                  />

                  <!-- Upload / Add More Button -->
                  <button
                    *ngIf="!lastTollFileName"
                    type="button"
                    class="btn btn-dark"
                    style="width: 140px"
                    (click)="chooseFile()"
                  >
                    Upload
                  </button>

                  <button
                    *ngIf="lastTollFileName"
                    type="button"
                    class="btn btn-dark"
                    style="width: 140px"
                    (click)="chooseFile()"
                  >
                    Add More
                  </button>
                </div>

                <!-- Preview thumbnails -->
                <div
                  class="d-flex flex-wrap gap-3 mt-3"
                  *ngIf="previewTollFiles?.length > 0"
                >
                  <div
                    *ngFor="let file of previewTollFiles; let i = index"
                    class="position-relative border rounded shadow-sm bg-white"
                    style="width: 120px; height: 120px; overflow: hidden"
                  >
                    <!-- Remove button -->
                    <button
                      type="button"
                      class="btn btn-sm btn-danger position-absolute"
                      style="top: 2px; right: 2px; z-index: 10; padding: 0 6px"
                      (click)="removeFile(i)"
                    >
                      &times;
                    </button>

                    <!-- Image Preview -->
                    <ng-container *ngIf="isImage(file); else pdfIcon">
                      <img
                        [src]="getFileSrc(file)"
                        alt="preview"
                        class="w-100 h-100"
                        style="object-fit: cover; border-radius: 4px"
                      />
                      <button
                        type="button"
                        class="btn btn-sm position-absolute text-white fw-semibold"
                        style="
                          bottom: 50px;
                          left: 50%;
                          transform: translateX(-50%);
                          background: rgba(0, 0, 0, 0.6);
                          border: none;
                          font-size: 12px;
                          padding: 5px 10px;
                          border-radius: 6px;
                          backdrop-filter: blur(2px);
                        "
                        (click)="viewImage(getFileSrc(file))"
                      >
                        Preview
                      </button>
                    </ng-container>

                    <!-- PDF Preview -->
                    <ng-template #pdfIcon>
                      <div
                        class="d-flex justify-content-center align-items-center h-100"
                      >
                        <i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm position-absolute text-white fw-semibold"
                        style="
                          bottom: 50px;
                          left: 50%;
                          transform: translateX(-50%);
                          background: rgba(0, 0, 0, 0.6);
                          border: none;
                          font-size: 12px;
                          padding: 5px 10px;
                          border-radius: 6px;
                          backdrop-filter: blur(2px);
                        "
                        (click)="viewPDF(file)"
                      >
                        Preview
                      </button>
                    </ng-template>
                  </div>
                </div>

                <!-- Message when no attachments -->
                <div
                  class="text-muted fst-italic mt-2"
                  *ngIf="!previewTollFiles?.length"
                >
                  No attachments uploaded yet.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12 mb-2">
          <div class="contentbox mt-3">
            <div class="row account">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-xl-12">
                    <div
                      class="d-flex align-items-baseline justify-content-between"
                    >
                      <h1 class="fs-4 fw-bold mb-0">Invoice Details</h1>
                      <button
                        class="btn btn-dark btn-sm"
                        mat-raised-button
                        (click)="addnewinv(this.particlarLR?._id)"
                      >
                        + Add New Invoice
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3 table-responsive">
                <table
                  datatable
                  class="tablelist"
                  *ngIf="this.particlarLR?.invoice_no?.length > 0"
                >
                  <thead>
                    <tr>
                      <th>Number of Article</th>
                      <th>Invoice No.</th>
                      <th>Customer Name</th>
                      <th>Invoice Value</th>
                      <th>Weight</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let inv of this.particlarLR?.invoice_no">
                      <td>{{ inv.NoofArticle || "N/A" }}</td>
                      <td>{{ inv.InvoiceNo || "N/A" }}</td>
                      <td>{{ inv.customerName || "N/A" }}</td>
                      <td>{{ inv.InvoiceValue || "N/A" }}</td>
                      <td>{{ inv.Weight || "N/A" }}</td>
                      <td>
                        <button
                          (click)="editInvoice(inv, this.particlarLR?._id)"
                          class="btn btn-block p-0 shadow-none"
                        >
                          <i matTooltip="Edit" class="fas fa-pen"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-end">
          <button
            (click)="updateLRSubmit()"
            class="btn btn-dark"
            type="submit"
            mat-raised-button
          >
            Update
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
